import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import {getAutomation} from "@app/services/automations.ts";

export const useAutomationViewPage = () => {
  const navigate = useNavigate();
  const param = useParams();
  const {
    data: automationData,
    isLoading,
  } = useQuery({
    queryKey: [`automation-${param.id}`],
    queryFn: () => getAutomation(param?.id as string),
    enabled: !!param.id,
  });

  return {
    navigate,
    automationData,
    isLoading,
  };
}; 